import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SplitPane from 'react-split-pane'
import classnames from 'classnames'
import Clickable from '../Clickable'
import ReactDOM from 'react-dom'
import { rewriteEbookUrl } from '../../../shared/lib/ebookUrl'
import AutoFocus from '../AutoFocus'

import style from './style.css'
import baseStyle from 'Styles/base.css'

import newTabImg from 'Assets/vs_maximize_icons_383838.png'
import closeImg from  'Assets/x-icon-gray.svg'

export function isVitalSourceURL (string, parseEbookString) {
  let potentialUrl = /\s*\[\[(.*)\]\]\s*/.exec(string)
  let potentialTitle = /^(.*?)[[]/.exec(string)
  const a = document.createElement('a')

  if (parseEbookString === true) {
    if (potentialUrl != null) {
      potentialUrl = potentialUrl[1]
    } else {
      potentialUrl = string
    }

    if (potentialTitle != null) {
      potentialTitle = potentialTitle[1]
    } else {
      potentialTitle = string
    }

    a.href = potentialUrl
  } else {
    a.href = string
  }

  if (a.host && a.host !== window.location.host) { // is VitalSource (is URL and external host)
    if (parseEbookString === true) {
      return { url: a.href, title: potentialTitle, isLegacyEbook: false }
    } else {
      return true
    }
  } else {
    if (parseEbookString === true) {
      return { title: string, isLegacyEbook: true }
    } else {
      return false
    }
  }
}

export default class LCSplitPane extends Component {
  constructor (props) {
    super(props)
    // This state is tracking whether or not the user is dragging the SplitPane borders to change
    // its sizing.  If so, then we have to set the child elements to "pointer-events: none" so
    // the child events don't prevent smooth dragging. See https://github.com/tomkp/react-split-pane/issues/30
    this.state = {
      isDragging: false
    }
  }

  componentDidMount () {
    /* this controls the resizing of the footer when the screen is split
     * for performance reasons, only recalculate if the width has changed in the last
     * 25 milliseconds
     */
    const footerCalc = this.props.outerFooterCalc
    const splitPaneElement = document.getElementsByClassName('SplitPane')
    let pane2current = splitPaneElement[0].offsetWidth
    let callback
    ReactDOM.findDOMNode(this).getElementsByClassName('Resizer')[0].addEventListener('mousedown', function () {
      callback = setInterval(function () {
        if (splitPaneElement[0] &&
          pane2current !== splitPaneElement[0].getElementsByClassName('Pane2')[0].offsetWidth) {
          pane2current = splitPaneElement[0].getElementsByClassName('Pane2')[0].offsetWidth
          footerCalc(pane2current)
        }
      }, 25)
    })
    ReactDOM.findDOMNode(this).getElementsByClassName('Resizer')[0].addEventListener('mouseup', function () {
      clearInterval(callback)
    })
  }

  openNewTab (url) {
    const w = window.open(url)
    w.document.close()
  }

  onKeyDown (event) {
    if (event.keyCode === 13) {
      event.target.click()
      event.preventDefault()
    }
  }

  // this is parted out from the render method since it doesn't need to render in Launchpad
  renderNewTab (url) {
    return (
      <Clickable
        data-test-id="openSplitScreenNewTabBtn"
        onClick={() => this.openNewTab(url)}
        onKeyDown={(event) => this.onKeyDown(event)}
        tabIndex="0"
      >
        <img
          src={newTabImg}
          className={style.splitImgIcon}
          alt="Open Split Screen Ebook in new tab"
          tabIndex="-1"
        />
      </Clickable>
    )
  }

  render () {
    let ebookData = {}

    if (this.props.PSPItem && typeof this.props.PSPItem === 'object') {
      ebookData.title = this.props.PSPItem.displayValue
      if (isVitalSourceURL(this.props.PSPItem.pageId)) {
        ebookData.url = this.props.PSPItem.pageId
      } else {
        ebookData.isLegacyEbook = true
      }
    } else if (this.props.ActivityScoreData && typeof this.props.ActivityScoreData === 'object') {
      ebookData = isVitalSourceURL(this.props.ActivityScoreData.curCard.meta.ebook, true)
      ebookData.title = ebookData.isLegacyEbook ? this.props.ActivityScoreData.curCard.meta.ebook : ebookData.title
    }

    let title = ebookData.title
    let url = ebookData.url

    url = rewriteEbookUrl(url)

    let legacyIframeClass, legacyRightClass, legacyResizerClass, legacyTitlebarClass

    const bumpDownClass = this.props.isPreview ? style.bumpDownClass : ''

    const resizerBump = this.props.isInstructor ? style.resizerInstructor : style.resizerBump

    if (title && title.indexOf('[[') > 0) {
      title = title.split('[[')[0]
    }

    if (title) {
      title = title.length > 50
        ? title.substr(0, 50) + '&#8230;'
        : title
    }

    const toggleInteractive = classnames([
      { [style.notInteractive]: this.state.isDragging === true },
      { [style.isInteractive]: this.state.isDragging === false }
    ])

    return (
      <SplitPane
        onDragStarted={() => {
          this.setState({
            isDragging: true
          })
        }}
        onDragFinished={() => {
          this.setState({
            isDragging: false
          })
        }}
        split="vertical"
        defaultSize={this.props.lastWidth}
        primary="second"
        className={classnames(style.resizer, resizerBump, legacyResizerClass)}
      >
        {this.props.children}
        <AutoFocus className={style.rightContentContainer}>
          <div ref="rightPane" className={classnames(style.rightContent, legacyRightClass, bumpDownClass)}>
            <div className={classnames(style.dockTitleBar, legacyTitlebarClass)}>
              <div className={style.dockTitleContainer}>
                <span className={style.splitTitle}>e-Book Section</span>
              </div>
              <div className={style.dockButtonContainer}>
                <Clickable
                  data-test-id="closeSplitScreenEbook"
                  className={style.headerClickableRight}
                  onClick={this.props.toggle}
                  onKeyDown={(event) => this.onKeyDown(event)}
                  aria-label={'Close split screen ebook'}
                  tabIndex="0"
                >
                  <object
                    data={closeImg} type="image/svg+xml"
                    className={classnames(baseStyle.svgIcon, style.splitSvgIcon)}
                    tabIndex="-1"
                  />
                </Clickable>
                {this.renderNewTab(url)}
              </div>
            </div>
            <div className={classnames(style.splitContentWrapper, toggleInteractive)} tabIndex="0">
              <iframe
                src={url}
                id="splitScreenEbook"
                className={classnames(style.splitContent, legacyIframeClass)}
                name={title}
                title={title}
              />
            </div>
          </div>
        </AutoFocus>
      </SplitPane>
    )
  }
}

LCSplitPane.propTypes = {
  browser: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  toggle: PropTypes.func.isRequired,
  isPreview: PropTypes.bool,
  isInstructor: PropTypes.bool,
  PSPItem: PropTypes.object,
  ActivityScoreData: PropTypes.object,
  outerFooterCalc: PropTypes.func,
  lastWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}
